<div class="modal-header" id="docbox-tabbed-modal-title">
    <h3 class="modal-title" id="modal-title">{{ 'DASHBOARD_DOCBOX_TABBED_MODAL_TITLE' | translate }}</h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body">
    <tabset [justified]="true">
        <tab [heading]="notificationModalTabHeaders.notificationHistoryTabTitle">
            <pace-docbox-notification-history> </pace-docbox-notification-history>
        </tab>
        <tab [heading]="notificationModalTabHeaders.docBoxFreeSearchTabTitle">
            <pace-docbox-free-search></pace-docbox-free-search>
        </tab>
    </tabset>
</div>
